var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.527 0 .515 2.236.515 4.984V8A6.026 6.026 0 0 0 0 10.443C0 13.513 2.238 16 5 16s5-2.487 5-5.557c0-.877-.19-1.705-.515-2.443V4.984C9.485 2.236 7.473 0 5 0zm0 1.894c1.533 0 2.78 1.387 2.78 3.09v.841A4.637 4.637 0 0 0 5 4.887a4.628 4.628 0 0 0-2.78.938v-.84c0-1.704 1.247-3.09 2.78-3.09zM5 8.37c.53 0 .955.471.955 1.059 0 .341-.14.64-.363.835l.242 2.255H4.168l.245-2.255a1.112 1.112 0 0 1-.368-.835c0-.588.425-1.059.955-1.059z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.a850013e0a4e3e56deaf3c0c824585a8.svg";
export { ForwardRef as ReactComponent };